import DecedentMainInfo from '@/common/containers/Forms/DecedentMainInfo/DecedentMainInfo';

export default DecedentMainInfo;
